import { type FragmentOf, readFragment } from "@opensea/graphql"
import { head } from "es-toolkit/array"
import { readSwapImpactFragment } from "./readSwapImpact.fragment"
import type { SwapQuote } from "./SwapProvider"

export const readSwapImpact = (
  swapRouteKey: FragmentOf<typeof readSwapImpactFragment>,
) => {
  const swapRoute = readFragment(readSwapImpactFragment, swapRouteKey)
  if (swapRoute?.__typename !== "SwapRoute") {
    return undefined
  }
  return swapRoute.swapImpact
}

export const readSwapImpactFromQuote = (swapQuote: SwapQuote) => {
  const swapRoute = head(swapQuote.swapRoutes)
  if (swapRoute?.__typename !== "SwapRoute") {
    return undefined
  }
  return readSwapImpact(swapRoute)
}
